import WaterDroplet from '~/images/icons/water-droplet-with-outline.svg';
import cx from 'classnames';
import store from '~/javascripts/store.js';
import { observer } from 'mobx-react';

const CalmDonationFrequencyToggle = observer(() => {
  const toggle = (isSubscription) => {
    store.donateForm.isSubscription = isSubscription;

    store.donateForm.step = 'amount';
    store.donateForm.creditCardStep = 1;
    store.donateForm.phoneNumber.hiddenFieldValue = '';
    store.donateForm.setCustomDefaultAmount();
    store.donateForm.setOptimizelyAmount();
    store.donateForm.isWpsAmountButtonSelected = false;
    store.donateForm.setSelectedPaymentTab();

    if (store.donateForm.subscriptionUpsell.isOptedIn) {
      store.donateForm.subscriptionUpsell.toggleIsOptedIn(
        store.donateForm.isAnnual ? 'annual' : 'monthly',
        false
      );
    }

    store.donateForm.subscriptionUpsell.originalPeriod =
      store.donateForm.frequency;
  };

  return (
    <div className='flex justify-around'>
      <div
        className={cx('calm-amount-option toggle-monthly flex justify-center', {
          selected: store.donateForm.isSubscription,
        })}
        onClick={() => toggle(true)}
      >
        <div>Monthly</div>
        <img src={WaterDroplet} />
      </div>
      <div
        className={cx('calm-amount-option toggle-one-time', {
          selected: !store.donateForm.isSubscription,
        })}
        onClick={() => toggle(false)}
      >
        Give once
      </div>
    </div>
  );
});

export default CalmDonationFrequencyToggle;
